import { BehaviorSubject } from "rxjs";
import { requestOptions } from "../_helpers/request-options";
import { handleResponse } from "../_helpers/handle-response";
import store from "../store/store.js";
store.getters.config;
import { repository } from "./repository";
import { token } from "./token";
import { globalFunctions } from "./globalFunctions";
import { secureState } from "../_services/secureState";
import { ReplaySubject } from "rxjs";

let currentUserSubject = new BehaviorSubject();

//const currentUserSubject = new BehaviorSubject(store.state.currentUser);

export const anonymousService = {
  login,
  generateSaleOrderAgreement,
  generateSaleOrderAgreement2,
  generateCustomerCommentForm,
  saveCustomerComment,

  logout,
  recover,
  validateState,
  passwordChange,
  initialUserData,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
};
let ctr = 0;
function validateState() {
  try {
    const vuex = JSON.parse(secureState.get("vuex"));
    if (vuex && vuex.userData) {
      currentUserSubject = new BehaviorSubject(vuex.userData);
      store.commit("USER_DATA", vuex.userData);
      currentUserSubject.next(store.state.userData);
      return true;
    }
  } catch (e) {
    console.warn("invalid state!", e);
  }
}
let initialUserData = {};

function generateSaleOrderAgreement(key) {
  console.log(requestOptions.generateSaleOrderAgreement({ key: key }));
  return fetch(window.api + "Anonymous/GenerateSaleOrderAgreement", requestOptions.generateSaleOrderAgreement({ key: key }))
    .then(handleResponse)
    .catch((err) => {
      console.warn(err);
    })
    .then((user) => {
      if (user.entity.token != null) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        try {
          currentUserSubject = new BehaviorSubject(user.entity);
          store.state.userData = JSON.parse(JSON.stringify(user.entity));
          store.commit("USER_DATA", user.entity);
          this.initialUserData = user.entity;
          currentUserSubject.next(user.entity);
        } catch (exc) {
          console.warn(exc);
        }
      }

      return user;
    })
    .catch((error) => {
      console.warn("token error", error);
      return error;
    });
}

async function generateCustomerCommentForm(key) {
  return fetch(window.api + "Anonymous/GenerateCustomerCommentForm", requestOptions.generateSaleOrderAgreement({ key: key }))
    .then(handleResponse)
    .catch((err) => {
      console.warn(err);
    })
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.warn("generateCustomerCommentForm error", error);
      return error;
    });
}

async function saveCustomerComment(key) {
  return fetch(window.api + "Anonymous/SaveCustomerComment", requestOptions.generateAnonymous(key))
    .then(handleResponse)
    .catch((err) => {
      throw err;
    })
    .then((result) => {
      return result;
    })
    .catch((error) => {
      throw error;
    });
}

async function generateSaleOrderAgreement2(key) {
  let response = await fetch("https://giris.nitrobilisim.com.tr/api/Anonymous/GenerateSaleOrderAgreement", {
    headers: {
      accept: "*/*",
      "accept-language": "en-US,en;q=0.9,tr;q=0.8",
      "content-type": "application/json",
      "sec-fetch-dest": "empty",
      "sec-fetch-mode": "cors",
      "sec-fetch-site": "cross-site",
    },
    referrer: "https://panel.nitrobilisim.com.tr/",
    referrerPolicy: "strict-origin-when-cross-origin",
    body: '{"key":"' + key + '"}',
    method: "POST",
    mode: "cors",
    credentials: "omit",
  });

  //let response2 = await fetch("https://localhost:44381/api/Anonymous/GenerateSaleOrderAgreement3/key=2}");
}
function logout() {
  // remove user from local storage to log user out
  for (let i = 0; i < 1000; i++) {
    clearInterval(i);
  }
  navigator.timers = null;
  sessionStorage.clear();
  localStorage.clear();
  if (currentUserSubject) currentUserSubject.next(null);
}
function recover(email) {
  console.warn(email);
  //repository.postEntity("User/forgetPassword?email=" + email);

  return fetch(window.api + "User/forgetPassword?email=" + email, requestOptions.recoverEmail({ email: email }))
    .then(handleResponse)
    .catch((err) => {
      console.warn(err);
    })
    .then((user) => {
      if (user.entity.token != null) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        try {
          currentUserSubject = new BehaviorSubject(user.entity);
          store.state.userData = JSON.parse(JSON.stringify(user.entity));
          store.commit("USER_DATA", user.entity);
          this.initialUserData = user.entity;
          currentUserSubject.next(user.entity);
        } catch (exc) {
          console.warn(exc);
        }
      }

      return user;
    })
    .catch((error) => {
      console.warn("token error", error);
      return error;
    });
}

function passwordChange(token, password) {
  return fetch(window.api + "User/passwordChange", requestOptions.resetPasswordvm({ token: token, newPass: password }))
    .then(handleResponse)
    .catch((err) => {
      console.warn(err);
    })
    .then((user) => {
      if (user.entity.token != null) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        try {
          currentUserSubject = new BehaviorSubject(user.entity);
          store.state.userData = JSON.parse(JSON.stringify(user.entity));
          store.commit("USER_DATA", user.entity);
          this.initialUserData = user.entity;
          currentUserSubject.next(user.entity);
        } catch (exc) {
          console.warn(exc);
        }
      }

      return user;
    })
    .catch((error) => {
      console.warn("token error", error);
      return error;
    });
}

function login(mail, password, keyParam) {
  return fetch(window.api + "Anonymous/GenerateSaleOrderAgreement", requestOptions.generateSaleOrderAgreement({ mail: mail, password: password, token: token.get(), key: keyParam }))
    .then(handleResponse)
    .catch((err) => {
      console.warn(err);
    })
    .then((user) => {
      if (user.entity.token != null) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        try {
          currentUserSubject = new BehaviorSubject(user.entity);
          store.state.userData = JSON.parse(JSON.stringify(user.entity));
          store.commit("USER_DATA", user.entity);
          this.initialUserData = user.entity;
          currentUserSubject.next(user.entity);
        } catch (exc) {
          console.warn(exc);
        }
      }

      return user;
    })
    .catch((error) => {
      console.warn("token error", error);
      return error;
    });
}

function loginOrg(mail, password) {
  return fetch(window.api + "User/authenticate", requestOptions.login({ mail: mail, password: password, token: token.get() }))
    .then(handleResponse)
    .catch((err) => {
      console.warn(err);
    })
    .then((user) => {
      if (user.entity.token != null) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        try {
          currentUserSubject = new BehaviorSubject(user.entity);
          store.state.userData = JSON.parse(JSON.stringify(user.entity));
          store.commit("USER_DATA", user.entity);
          this.initialUserData = user.entity;
          currentUserSubject.next(user.entity);
        } catch (exc) {
          console.warn(exc);
        }
      }

      return user;
    })
    .catch((error) => {
      console.warn("token error", error);
      return error;
    });
}
